<app-lang-switch position="absolute"></app-lang-switch>
<div class="container flex" [formGroup]="setPasswordForm">
  <div class="widget loginFormContainer flex flex-column gap-4 p-6">
    <h2>{{ "auth.password_set.title" | translate }}</h2>
    <div class="flex flex-column gap-2 mb-3 relative">
      <div class="flex gap-2 align-items-center">
        <label for="password" class="font-semibold">{{ "auth.password_set.password" | translate }}</label>
        <app-svg-icon
          iconName="info-circle"
          tooltipPosition="bottom"
          [pTooltip]="translate.instant('auth.password_set.password_hint')"
          iconColor="secondary"
          class="flex"
        >
        </app-svg-icon>
        <i
          class="pi pi-info-circle"
          tooltipPosition="bottom"
          [pTooltip]="translate.instant('auth.password_set.password_hint')"
        ></i>
      </div>

      <input
        pInputText
        id="password"
        [type]="passwordVisible() ? 'text' : 'password'"
        formControlName="password"
        autocomplete="off"
        (keyup)="onKeyUp($event)"
        class="pr-5"
      />
      <app-svg-icon
        (click)="togglePasswordVisibility()"
        iconName="eye"
        iconColor="primary"
        style="right: 1rem; top: 2.3rem"
        class="p-link absolute"
        tabindex="-1"
      />
    </div>
    <div class="flex flex-column gap-2 mb-3 relative">
      <label for="passwordRepeat" class="font-semibold">{{ "auth.password_set.password_repeat" | translate }}</label>
      <input
        pInputText
        id="passwordRepeat"
        [type]="passwordRepeatVisible() ? 'text' : 'password'"
        formControlName="passwordRepeat"
        autocomplete="off"
        (keyup)="onKeyUp($event)"
        class="pr-5"
      />
      <app-svg-icon
        (click)="togglePasswordRepeatVisibility()"
        iconName="eye"
        iconColor="primary"
        style="right: 1rem; top: 2.1rem"
        class="p-link absolute"
        tabindex="-1"
      />
    </div>
    @if (saveClicked() && !setPasswordForm.valid) {
      <p class="validation-message" role="alert">
        @if (setPasswordForm.controls["password"].invalid || setPasswordForm.controls["passwordRepeat"].invalid) {
          {{ "auth.password_set.password_hint" | translate }}
        } @else {
          {{ "auth.password_set.password_mismatch" | translate }}
        }
      </p>
    }

    <app-button
      (click)="setPassword()"
      [disabled]="!setPasswordForm.valid"
      [block]="true"
      buttonText="auth.password_set.set_button"
    ></app-button>
  </div>
</div>
